import request from '@/utils/request';

//今日行为数据概览
export function queryDataOverview(values) {
  return request('/tracking-report/queryDataOverview', {
    method: 'POST',
    data: values,
  });
}

//行为数据统计对比
export const queryDataBehaveCompare = (params) => {
  return request('/tracking-report/queryDataBehaveCompare', {
    method: 'POST',
    data: params,
  });
};

//热门功能top
export function queryHighFrequencyFunction(values) {
  return request('/tracking-report/queryHighFrequencyFunction', {
    method: 'POST',
    data: values,
  });
}

//高频用户top
export function queryHighFrequencyUser(values) {
  return request('/tracking-report/queryHighFrequencyUser', {
    method: 'POST',
    data: values,
  });
}

//查询事件类型下拉框
export function queryTrackIngObjectList(values) {
  return request('/tracking-report/queryTrackIngObjectList', {
    method: 'POST',
    data: values,
  });
}

//查询权限组
export function queryAllRole(values) {
  return request('/tracking-report/queryAllRole', {
    method: 'POST',
    data: values,
  });
}

//下载行为事件统计列表
export function downLoadBehaveCompareList(values) {
  return request('/tracking-report/downLoadBehaveCompareList', {
    method: 'POST',
    data: values,
  });
}

//行为事件统计对比列表
export function queryDataBehaveCompareList(values) {
  return request('/tracking-report/queryDataBehaveCompareList', {
    method: 'POST',
    data: values,
  });
}
